import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
import FirstPageStore from '@src/pages/main/components/first-page/store';
import AgeAppropriateTips from '@src/components/age-appropriate-tips';
import Link from '@src/components/link';
import { ACTIVITY_STATUS } from './store';
import $$tracker from '@src/tracker';
import KvVideo from './components/kv-video';
/**
 * FirstPage
 * @param store {FirstPageStore}
 * @returns {JSX.Element}
 * @constructor
 */
const FirstPage = ({ store }) => {
  store.use();
  const { layerData, localData, $globalStore } = store;

  const RenderPlatformLink = () => {
    return (
      <div className={cx(styles.platformGroup, 'first-page-group-1')} data-name="logo">
        <Link
          href={layerData.xbox_link}
          target={'_blank'}
          className="first-page-layer-2"
          data-name="image"
          onClick={() => {
            $$tracker.clickXbox();
          }}
          style={{ backgroundImage: `url(${localData.xboxLogo})` }}
        />
        <Link
          href={layerData.steam_link}
          target={'_blank'}
          className="first-page-layer-3"
          data-name="steam"
          onClick={() => {
            $$tracker.clickSteam();
          }}
          style={{ backgroundImage: `url(${localData.steamLogo})` }}
        />
      </div>
    );
  };

  const RenderADBtn = () => {
    const isDownload = $globalStore.isDownloadStage;
    const endlishDecoration = isDownload ? require('./images/adBtn/download-sub.png') : require('./images/adBtn/pre-sub.png');
    return (
      <div className={styles.renderAdBtn}>
        <div className={styles.rootWarp}>
          <div data-name="底层border" className={styles.basicBg} />
          <div data-name="顶层背景组" className={styles.topBgGroup}>
            <div data-name="纹理背景" className={styles.texture} />
            <div data-name="按钮边框动画组" className={styles.btnBorderAnimGroup}>
              <div data-name="上" className={styles.topGroup}>
                <div className={styles.border} />
              </div>
              <div data-name="右" className={styles.rightGroup}>
                <div className={styles.border} />
              </div>
              <div data-name="下" className={styles.bottomGroup}>
                <div className={styles.childGroup}>
                  <img alt="" src={require('./images/adBtn/top-border.png')} className={styles.bottomBorder} />
                </div>
              </div>
              <div data-name="左" className={styles.leftGroup}>
                <div className={styles.childGroup}>
                  <img alt="" src={require('./images/adBtn/top-border.png')} className={styles.leftBorder} />
                </div>
              </div>
            </div>
            <div data-name="左侧光影组" className={styles.leftShadowGroup}>
              <div data-name="bg-1" className={styles.bg1} />
              <div data-name="bg-2" className={styles.bg2} />
              <div data-name="bg-3" className={styles.bg3} />
              <div data-name="bg-4" className={styles.bg4} />
              <div className={styles.hoverGroup}>
                <div data-name="bg-1" className={styles.bgHover1} />
                <div data-name="bg-2" className={styles.bgHover2} />
                <div data-name="bg-3" className={styles.bgHover3} />
              </div>
            </div>
            <div data-name="右侧光影组" className={styles.rightShadowGroup}>
              <div data-name="bg-1" className={styles.bg1} />
              <div data-name="bg-2" className={styles.bg2} />
              <div data-name="bg-3" className={styles.bg3} />
              <div data-name="bg-4" className={styles.bg4} />
              <div className={styles.hoverGroup}>
                <div data-name="bg-1" className={styles.bgHover1} />
                <div data-name="bg-2" className={styles.bgHover2} />
                <div data-name="bg-3" className={styles.bgHover3} />
              </div>
            </div>
            <div data-name="英文装饰" className={styles.decoration}>
              <img alt="" className={styles.left} src={endlishDecoration} />
              <img alt="" className={styles.right} src={endlishDecoration} />
            </div>
            <div data-name="按钮内容" className={styles.btnContent}>
              {isDownload ? (
                <Link
                  onClick={() => {
                    $$tracker.clickDownload();
                  }}
                  className={cx(styles.contentBtn)}
                  data-name="下载按钮"
                  href={layerData.download_link}
                >
                  下载游戏
                  <div className={styles.iconGroup}>
                    <div className={styles.icon1} />
                    <div className={styles.icon2} />
                  </div>
                </Link>
              ) : (
                <Link
                  clickEffect="opacity"
                  className={cx(styles.contentBtn)}
                  data-name="立即预约"
                  onClick={() => {
                    store.book();
                  }}
                >
                  立即预约
                  <div className={styles.iconGroup}>
                    <div className={styles.icon1} />
                    <div className={styles.icon2} />
                  </div>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const RenderActivityEntry = () => {
    return (
      <div className={cx(styles.activityEntry)} data-name="活动入口">
        {store.activityList.map(
          (item, index) =>
            item.activity_state === ACTIVITY_STATUS.open && (
              <Link
                key={item.title}
                href={item.activity_url}
                target={'_blank'}
                className={styles.activityItem}
                data-name={item.title}
                onClick={() => {
                  $$tracker.clickCl(item.title, index + 3);
                }}
              >
                <div className={styles.activityItemInner} style={{ backgroundImage: `url(${item.cover_pc})` }} />
              </Link>
            )
        )}
      </div>
    );
  };

  const RenderVideoPlay = () => {
    return (
      <div className={styles.videoPlay} onClick={store.onVideoPlay}>
        <div className={styles.videoPlayCover} style={{ backgroundImage: `url(${layerData.videoCover})` }} />
        <div className={styles.playIcon} />
      </div>
    );
  };

  return (
    <div className={cx(styles.root)}>
      <KvVideo store={store.kvVideoStore} cover={localData.kvUrl} src={localData.kvVideoLink} className={styles.kvVideo} />
      <div className="first-page-root">
        <RenderADBtn />
        <div className={styles.activityTime} />
        {RenderActivityEntry()}
        <RenderVideoPlay />
        <div className="first-page-layer-7" data-name="16+ ">
          <AgeAppropriateTips gameName={'解限机'} />
        </div>
      </div>
    </div>
  );
};

export default wrapStore(FirstPage, FirstPageStore);
